import api from '@/services/api'

export default () => !!api.clientData('user_is_expired')